import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';
import { useFeatureFlagsLocalStorage } from '@/features/dev-tools/_hooks/local-storage';
import { isDevMode } from '@/utils';
import type { z } from 'zod';
import { FeatureFlagsModel } from '../_models/feature-flags';

export const useFeatureFlags = (): {
  isLoading: boolean;
  features: z.infer<typeof FeatureFlagsModel>['features'] | undefined;
} => {
  const { myFeatureFlags } = useFeatureFlagsLocalStorage();
  const enabledDevTools = isDevMode() && myFeatureFlags?.enabled;

  const { data: featureFlags, isLoading } = useQuery({
    queryKey: ['featureFlags'],
    queryFn: async () => {
      const res = await axiosGet('/api/feature-flags/');
      return FeatureFlagsModel.parse(res);
    },
  });

  if (enabledDevTools && myFeatureFlags) {
    return {
      isLoading: false,
      features: myFeatureFlags.features,
    };
  }

  return {
    isLoading,
    features: featureFlags?.features,
  };
};
